module.exports = __webpack_public_path__ + "static/media/ticket-pending.a312b9ed.svg";